import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIcImproveBlueMark = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M15.9998 8C15.9998 12.4183 12.418 16 7.99976 16C3.58148 16 -0.000244141 12.4183 -0.000244141 8C-0.000244141 3.58172 3.58148 0 7.99976 0C12.418 0 15.9998 3.58172 15.9998 8Z",
			fill: "#6C9CFA"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M5.19976 8.2C5.19976 8.75229 4.75204 9.2 4.19976 9.2C3.64747 9.2 3.19976 8.75229 3.19976 8.2C3.19976 7.64772 3.64747 7.2 4.19976 7.2C4.75204 7.2 5.19976 7.64772 5.19976 8.2Z",
			fill: "#F2F4F8"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8.79976 8.2C8.79976 8.75229 8.35204 9.2 7.79976 9.2C7.24747 9.2 6.79976 8.75229 6.79976 8.2C6.79976 7.64772 7.24747 7.2 7.79976 7.2C8.35204 7.2 8.79976 7.64772 8.79976 8.2Z",
			fill: "#F2F4F8"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.3998 8.2C12.3998 8.75229 11.952 9.2 11.3998 9.2C10.8475 9.2 10.3998 8.75229 10.3998 8.2C10.3998 7.64772 10.8475 7.2 11.3998 7.2C11.952 7.2 12.3998 7.64772 12.3998 8.2Z",
			fill: "#F2F4F8"
		})
	]
});
export default SvgIcImproveBlueMark;
